import {
  SET_LIST_VENDOR_DATA,
  SET_LIST_VENDOR_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listVendorData: null,
  listVendorDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_VENDOR_DATA:
      return {
        ...state,
        loading: false,
        listVendorData: action.listVendorData,
      };

    case SET_LIST_VENDOR_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listVendorDataTotal: action.listVendorDataTotal,
      };

    default:
      return { ...state };
  }
};
